import { useEffect } from 'react';

import { identifyUser, resetPosthog } from '@/core/posthog-init';
import { AuthStatus, useAuthStore } from '@/core/store/auth.store';

/** Identify / reset PostHog when the auth session changes. */
export function usePosthogIdentify(): void {
  const authStatus = useAuthStore((s) => s.authStatus);
  const userId = useAuthStore((s) => s.user?.id);
  const email = useAuthStore((s) => s.user?.email);

  useEffect(() => {
    if (authStatus === AuthStatus.AUTHENTICATED && userId) {
      identifyUser(userId, email ? { email } : undefined);
      return;
    }

    if (authStatus === AuthStatus.UNAUTHENTICATED) {
      resetPosthog();
    }
  }, [authStatus, email, userId]);
}
